export default "__VITE_ASSET__CuWa4pCB__"